import { useLocation } from 'react-router-dom'
import { Link, NavItem, UserDropDown } from 'components'
import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { AdminMenu } from 'components/admin/AdminMenu/AdminMenu'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import { useIsSuperAdmin } from '@/hooks/utility/useIsSuperAdmin'

// Playfair Display ships with the app's bundled Google Fonts; the serif
// fallback renders if that face is ever missing.
const WORDMARK_FONT = "'Playfair Display', serif"

// The admin pages that render for any admin `useIsAdmin` admits, not only
// super admins: corporation admins, users acting as admin, and designer and
// QC edit-token tabs. Those admins reach them from the bar, since the admin
// menu and the admin home are a super admin's alone.
const SHARED_ADMIN_PAGES = [
  { text: 'MessengerPress', link: '/admin/messenger-press' },
  { text: 'PDF Jobs', link: '/admin/pdf-jobs' },
]

export const AdminNav = () => {
  const { pathname } = useLocation()
  const isSuperAdmin = useIsSuperAdmin()
  const isAdmin = useIsAdmin()

  return (
    // The parent <Navigation> uses justify="space-between" with 2 children:
    // the hamburger, wordmark and any page links as one left-aligned
    // cluster, and the user dropdown on the right.
    <>
      <Flex align="center" gap="16px">
        <AdminMenu />
        <Link href={isSuperAdmin ? '/admin' : '/dashboard'}>
          <Text
            font={WORDMARK_FONT}
            size="26px"
            weight="700"
            color="gray1"
            whiteSpace="nowrap"
          >
            MDL Admin
          </Text>
        </Link>
        {!isSuperAdmin && isAdmin && (
          <Flex align="center" gap="4px">
            {SHARED_ADMIN_PAGES.map((page) => (
              <NavItem
                key={page.link}
                text={page.text}
                link={page.link}
                selected={pathname === page.link}
              />
            ))}
          </Flex>
        )}
      </Flex>
      <UserDropDown />
    </>
  )
}

export default AdminNav
